import { IApplicationState } from '../../../types/redux';

export const selectIsFetching = (state: IApplicationState): boolean => {
  return state.mainpage.isFetching || false;
};
